import './BuildAllPracticeExamModal.css';

import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const MAX_AMOUNT_QUESTIONS = 1000;
const MAX_EXAM_TIME_IN_MINUTES = 600;

export default class BuildAllPracticeExamModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      amountQuestions: '',
      examTime: '',
      errors: {
        questions: null,
        time: null,
      },
      rebuildAll: false,
    };
  }

  handleBuildAllButtonPress = () => {
    const { amountQuestions, examTime } = this.state;
    const errors = { questions: null, time: null };

    const questions = amountQuestions === '' ? null : Number(amountQuestions);
    const time = examTime === '' ? null : Number(examTime);

    if (
      questions !== null &&
      (!Number.isFinite(questions) ||
        questions <= 0 ||
        questions >= MAX_AMOUNT_QUESTIONS)
    ) {
      errors.questions = `Question amount should be greater than 0 and less than ${MAX_AMOUNT_QUESTIONS}`;
    }

    if (
      time !== null &&
      (!Number.isFinite(time) || time <= 0 || time >= MAX_EXAM_TIME_IN_MINUTES)
    ) {
      errors.time = `Time value should be greater than 0 and less than ${MAX_EXAM_TIME_IN_MINUTES}`;
    }

    if (errors.questions || errors.time) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors });
    this.props.buildAllExams(questions, time, this.state.rebuildAll);
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>Build All</ModalHeader>

        <ModalBody>
          <div className="build-all-modal-form">
            <p>
              This builds the missing weekly practice exams for every rating
              exam of the <strong>active cycles</strong>.{' '}
              {this.state.rebuildAll
                ? "Exams that already have one for this week get its questions drawn again, over the same exam: it doesn't create a second one."
                : 'Exams that already have one for this week are left untouched.'}
            </p>

            {/* AMOUNT OF QUESTIONS SELECTOR */}
            <div className="build-all-modal-form-group">
              <label htmlFor="amountOfQuestions">Amount of questions:</label>
              <input
                id="amountOfQuestions"
                className="form-control exam-settings-input"
                type="number"
                value={this.state.amountQuestions}
                placeholder="Leave empty to keep each exam's own"
                onChange={(e) =>
                  this.setState({ amountQuestions: e.target.value })
                }
              />
              {this.state.errors.questions && (
                <small style={{ color: 'red' }}>
                  {this.state.errors.questions}
                </small>
              )}
            </div>

            {/* TIME SELECTOR */}
            <div className="build-all-modal-form-group">
              <label htmlFor="examTime">Exam time (mins):</label>
              <input
                id="examTime"
                className="form-control exam-settings-input"
                type="number"
                value={this.state.examTime}
                placeholder="Leave empty to keep each exam's own"
                onChange={(e) => this.setState({ examTime: e.target.value })}
              />
              {this.state.errors.time && (
                <small style={{ color: 'red' }}>{this.state.errors.time}</small>
              )}
            </div>

            <div className="build-all-modal-checkbox-single">
              <label>
                <input
                  type="checkbox"
                  checked={this.state.rebuildAll}
                  onChange={() =>
                    this.setState({
                      rebuildAll: !this.state.rebuildAll,
                    })
                  }
                />
                Re-build the exams already built for this week
              </label>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => this.handleBuildAllButtonPress()}
          >
            Build All
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
